export default __webpack_public_path__ + "static/media/background.b9fa005b.jpg";